var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-profile-page',[_c('user-businesses',{attrs:{"user":_vm.profile},on:{"business-updated":_vm.businessUpdate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }